import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "speciesIcon",
  standalone: false
})
export class SpeciesIconPipe implements PipeTransform {
  transform(species: string | undefined, notDefinedValue?: string): string {
    return speciesIconOrDefault(species, notDefinedValue);
  }
}

export function speciesIconOrDefault(
  species: string | undefined,
  notDefinedValue?: string
): string {
  return (
    speciesIcon(species) || notDefinedValue || "fa-light fa-question-circle"
  );
}

export function speciesIcon(species: string | undefined): string | undefined {
  switch (species) {
    case "canine":
    case "dog": {
      return "fa-solid fa-dog";
    }
    case "cat": {
      return "fa-solid fa-cat";
    }
    case "rabbit": {
      return "fa-solid fa-rabbit";
    }
    case "bird": {
      return "fa-solid fa-bird";
    }
    case "equine": {
      return "fa-solid fa-horse";
    }
    default: {
      return undefined;
    }
  }
}
